/**
 * Le journal des odeurs.
 *
 * Un signalement de fumée passe devant toutes les autres sources : le nez
 * détecte des choses qu'aucun capteur à 20 km ne mesure. Et on s'habitue vite
 * à une odeur, d'où l'intérêt de la noter pour pouvoir comparer plus tard.
 */
import { formatClock } from '../../core/format';
import type { AppState } from '../../state/store';
import { html, type Html } from '../html';

export function noseJournal(state: AppState, now: number): Html {
  const last = state.nose[0];

  return html`
    <section aria-labelledby="nose-title">
      <h3 class="section-title" id="nose-title">Ce que tu sens</h3>
      <div class="nose">
        <button type="button" class="yes" data-nose="smoke">Ça sent la fumée</button>
        <button type="button" class="no" data-nose="clear">Ça sent rien</button>
      </div>
      <p class="hint">
        ${last
          ? `Dernière fois : ${formatClock(last.at, now)}`
          : "On s'habitue vite à une odeur. Note-la, tu pourras comparer plus tard."}
      </p>
    </section>
  `;
}
